import { useQuery, gql } from "@apollo/client"
import { PlaidLink } from "@oysterhr/schema"

const PAYMENTS_COMPANY_GET_PLAID_TOKEN = gql`
  query PaymentsCompanyGetPlaidToken {
    plaidLink {
      token
    }
  }
`

const usePlaidToken = () => {
  const { data } = useQuery<{ plaidLink: PlaidLink }>(PAYMENTS_COMPANY_GET_PLAID_TOKEN)

  return { token: data?.plaidLink?.token || "" }
}

export default usePlaidToken
